export const TABLE_CLASSNAMES = {
  bordered: '',
  zebra: 'table-zebra',
}
